import React from "react";
import { Check } from "lucide-react";
import { Fade } from "react-awesome-reveal";

function MiniCard({ title, text }) {
  return (
    <Fade triggerOnce direction="up" duration={600}>
      <div className="bg-[#f8faff] rounded-[20px] p-[20px] flex flex-col gap-[15px] min-h-[118px] hover:-translate-y-[4px] transition-transform duration-300">
        <div className="flex items-center gap-[15px]">
          <div className="check-icon">
            <Check className="w-[12px] h-[12px] text-[#1c385f]" strokeWidth={2.5} />
          </div>
          <span className="font-['Inter'] font-bold text-[16px] text-[#1c385f]">{title}</span>
        </div>
        <p className="font-['Inter'] font-normal text-[14px] leading-[1.5] text-[#435c7f]">{text}</p>
      </div>
    </Fade>
  );
}

export default MiniCard;
